import { api } from "./api";
import type { SupplierLedger, BuyerLedger } from "@/types/models";

export const ledgerService = {
  getSupplierLedger: (supplierId: number) =>
    api.get<SupplierLedger>(`/suppliers/${supplierId}/ledger`).then((r) => r.data),

  getBuyerLedger: (buyerId: number) =>
    api.get<BuyerLedger>(`/buyers/${buyerId}/ledger`).then((r) => r.data),
};
